module.exports = function() {
  return new Worker(__webpack_public_path__ + "adad9c7d41097794a22d.worker.js");
};